import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Music } from "lucide-react";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center"
      >
        <div className="text-[#FFB347] text-9xl font-display font-bold mb-4">404</div>
        <h1 className="font-display text-3xl font-bold mb-4">Page non trouvée</h1>
        <p className="text-[#A8A29E] mb-8 max-w-md">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="btn-primary inline-flex items-center gap-2">
            <Home className="w-5 h-5" />
            Retour à l'accueil
          </Link>
          <Link to="/catalogue" className="btn-secondary inline-flex items-center gap-2">
            <Music className="w-5 h-5" />
            Voir le catalogue
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;
